// extracted by mini-css-extract-plugin
module.exports = {"ref":"Reference_ref__12aOr","iframe-container":"Reference_iframe-container__kd_HB","articles":"Reference_articles__2000x"};